// @ts-nocheck
// Page: consent-il-pay  (IL payment-required consent — subscription + disclosure + payment)
//
// Ported from the inline <script> in
//   Enrollment_modules/consent-il-pay/form.module/module.html (lines 171–4211).
//
// MECHANICAL PORT — runtime behaviour is preserved. Deliberate changes:
//   1. 2 inline event handlers stripped from markup and re-bound root-scoped
//      via bind() at end of init (ACH/CreditCard radio buttons).
//   2. enrollment.nautilussolar.com/_hcms/api/* -> apiUrl() (25 URLs).
//   3. Same-origin redirects -> root-relative paths.
//   4. localStorage -> storage.rawGet/rawSet/rawRemove.
//   5. @ts-nocheck for bare-minimum migration; proper typing is a follow-up.
// NOTE: document.querySelector('#page_3_payment_required_consent_widget ...')
//   reaches the HubSpot-generated module wrapper (parent of root) — these
//   selectors must stay document-scoped.
// NOTE: External hosts kept literal: aws.nautilussolar.com,
//   stripe.nautilussolar.com, portals.icheckgateway.com, api.na3.adobesign.com,
//   api.nautilussolar.com, api.ipify.org.
// NOTE: the subscription agreement lives in agreements/illinois/ as versioned
//   HTML assets and is fetched through js/src/agreements/consent-agreements.

import { createTemplateGate, loadAgreement } from "../../agreements/consent-agreements"
import { apiUrl } from "../../core/api"
import * as storage from "../../core/storage"
import { beginOperation, type LoadingOperationHandle } from "../../ui/loading-modal"

export function init(root: HTMLElement, _config: unknown): void {
__ea_trace("modules/consent/consent-il-pay.ts","init",[root,_config],["root","_config"]);
  const bind = (sel: string, type: string, fn: (e: any) => void) => {
__ea_trace("modules/consent/consent-il-pay.ts","bind",[sel,type,fn],["sel","type","fn"]);
    const el = root.querySelector(sel)
    if (el) el.addEventListener(type, fn)
  }

  var endprodORsbx = ""
  var email = storage.rawGet("userEmail")
  email = email.toLowerCase()
  const searchStringInEmail = "@test-nse.com"
  if (email.includes(searchStringInEmail)) {
    endprodORsbx = "sbx"
  } else {
    endprodORsbx = "prod"
  }

  // ─── Loading modal ─────────────────────────────────────────────────────────
  // Mechanical migration of the former fake-timer progress bar to the shared,
  // accessible loading modal (js/src/ui/loading-modal.ts). Kind "mutation" so a
  // genuine hang shows honest "may still be processing" copy with a Close escape,
  // never a fabricated 100%. The former 80s fake-timer sweep and the interval-leak
  // are gone by construction. A deferred audit will split this into read vs
  // mutation withLoader boundaries with abort/idempotency semantics.
  let loaderHandle: LoadingOperationHandle | null = null
  function openProgressBar(message = "We are generating your consent documents."): void {
__ea_trace("modules/consent/consent-il-pay.ts","openProgressBar",[message],["message"]);
    loaderHandle = beginOperation({ kind: "mutation", message })
  }
  function closeProgressBar(): void {
__ea_trace("modules/consent/consent-il-pay.ts","closeProgressBar",[],[]);
    loaderHandle?.complete()
    loaderHandle = null
  }

  var responseFromAPI = ""
  /* ---------------------- Make dynamic icheck iframe src ------------------------- */
  function ICCiframe() {
__ea_trace("modules/consent/consent-il-pay.ts","ICCiframe",[],[]);
    var FirstName = storage.rawGet("FirstName")
    var LastName = storage.rawGet("LastName")
    var RecordId = storage.rawGet("RecordId")
    var companyName = storage.rawGet("CompanyName")
    var iframe = document.getElementById("iFrameCC")
    // Set dynamic values
    var appId = "l63I6y1i7KAuldPia6zedbnVWM68lXZS"
    var appSecret = "1XHOeroaWB4kzhh6EjGxuCyQj60novml"
    var custId = RecordId
    var firstName = FirstName
    var lastName = LastName
    // Construct the dynamic src URL
    var dynamicSrc =
      "https://portals.icheckgateway.com/iFrame/iFrameCC.aspx?" +
      "appId=" +
      encodeURIComponent(appId) +
      "&appSecret=" +
      encodeURIComponent(appSecret) +
      "&custId=" +
      encodeURIComponent(custId) +
      "&firstName=" +
      firstName +
      "&lastName=" +
      lastName +
      "&company=" +
      companyName +
      "&css=payment{background:white;}"
    // Set the src attribute of the iframe

    iframe.src = dynamicSrc
  }
  function IBNiframe() {
__ea_trace("modules/consent/consent-il-pay.ts","IBNiframe",[],[]);
    var FirstName = storage.rawGet("FirstName")
    var LastName = storage.rawGet("LastName")
    var RecordId = storage.rawGet("RecordId")
    var iframe = document.getElementById("iFrameBN")
    var companyName = storage.rawGet("CompanyName")

    // Set dynamic values
    var appId = "l63I6y1i7KAuldPia6zedbnVWM68lXZS"
    // var appId = '222222';

    var appSecret = "1XHOeroaWB4kzhh6EjGxuCyQj60novml"
    // var appSecret = '222222';

    var custId = RecordId
    var firstName = FirstName
    var lastName = LastName
    // Construct the dynamic src URL
    var dynamicSrc =
      "https://portals.icheckgateway.com/iFrame/iFrameBA.aspx?" +
      "appId=" +
      encodeURIComponent(appId) +
      "&appSecret=" +
      encodeURIComponent(appSecret) +
      "&custId=" +
      encodeURIComponent(custId) +
      "&firstName=" +
      encodeURIComponent(firstName) +
      "&lastName=" +
      encodeURIComponent(lastName) +
      "&company=" +
      companyName +
      "&css=payment{background:white;}"
    // Set the src attribute of the iframe
    iframe.src = dynamicSrc
  }
  ICCiframe()
  IBNiframe()

  /* loader function */
  function _paymentRequiredOpenLoader() {
__ea_trace("modules/consent/consent-il-pay.ts","_paymentRequiredOpenLoader",[],[]);
    var loader = document.getElementById("paymentRequiredLoader")
    var _body = document.querySelector("body")
    var buttons = document.querySelectorAll("button")
    var anchors = document.querySelectorAll("a")
    document.getElementById("PRloaderOverlay").style.display = "block"
    loader.style.display = "flex"
    buttons.forEach((button) => {
__ea_trace("modules/consent/consent-il-pay.ts","(anon)",[button],["button"]);
      button.disabled = true
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/consent/consent-il-pay.ts","(anon)",[anchor],["anchor"]);
      anchor.disabled = true
    })
  }
  function _paymentRequiredCloseLoader() {
__ea_trace("modules/consent/consent-il-pay.ts","_paymentRequiredCloseLoader",[],[]);
    var loader = document.getElementById("paymentRequiredLoader")
    var _body = document.querySelector("body")
    var buttons = document.querySelectorAll("button")
    var anchors = document.querySelectorAll("a")
    document.getElementById("PRloaderOverlay").style.display = "none"
    loader.style.display = "none"
    buttons.forEach((button) => {
__ea_trace("modules/consent/consent-il-pay.ts","(anon)",[button],["button"]);
      button.disabled = false
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/consent/consent-il-pay.ts","(anon)",[anchor],["anchor"]);
      anchor.disabled = false
    })
  }
  /* loader function */

  // --- Go back personal information button ---------------------------------
  document
    .querySelector("#page_3_payment_required_consent_widget #goback-personal-info")
    .addEventListener("click", () => {
__ea_trace("modules/consent/consent-il-pay.ts","(anon)",[],[]);
      window.location.href = "/il-usage" // redirect to lmi bayou myusage page
    })
  // --- Go back personal information button ---------------------------------

  // If user is not logedIn then redirected them to login page -------------------------------------------------
  function _getEmail() {
__ea_trace("modules/consent/consent-il-pay.ts","_getEmail",[],[]);
    var storedEmail = storage.rawGet("userEmail")
    if (!storedEmail) {
      window.location.href = "/"
      return false
    }
  }

  ///this is the function for getting last month in expiry date........
  function getExpiryDateWithLastDay(expiryDate) {
__ea_trace("modules/consent/consent-il-pay.ts","getExpiryDateWithLastDay",[expiryDate],["expiryDate"]);
    const month = expiryDate.substring(0, 2)
    const year = `20${expiryDate.substring(2, 4)}` // Assuming the year is in the 2000s
    const lastDay = new Date(year, month, 0).getDate() // Get the last day of the month
    return `${month}/${lastDay.toString().padStart(2, "0")}/${year}`
  }
  function getExpiryDateWithISO(expiryDate) {
__ea_trace("modules/consent/consent-il-pay.ts","getExpiryDateWithISO",[expiryDate],["expiryDate"]);
    const month = expiryDate.substring(0, 2)
    const year = `20${expiryDate.substring(2, 4)}` // Assuming the year is in the 2000s
    const lastDay = new Date(year, month, 0).getDate() // Get the last day of the month
    const lastDayDate = new Date(Date.UTC(year, month - 1, lastDay))
    // month is zero-based in JavaScript Date
    return lastDayDate.toISOString()
  }

  // Getting values from iframe --------------------------------------------------------------------------------
  var iFrameRoutingNo
  var iFrameaccountNumber
  var iFrameaccountName
  var iFrameaccountType
  var _iFrameBankamount
  var iFrameBanktoken
  var _iFrameBankoperation
  var iFrameBanksource
  var iFrameCreditCardNo
  var iFrameCreditaccountName
  var iFrameCreditcardExpDate
  var _IFrameCreditamount
  var IFrameCreditcardType
  var _IFrameCreditcardOperation
  var IFrameCreditcardToken
  var IFrameCreditcardsource
  var iFrameCreditcardExpFullDate
  var iFrameCreditcardExpFullDateIso
  var IsCreditCheckDone = false
  var _IsValidateDisclosure = true
  var pageloaded = false
  var paymentResponse = ""
  window.addEventListener("message", async (e) => {
__ea_trace("modules/consent/consent-il-pay.ts","(anon)",[e],["e"]);
    var jsonData = e.data
    if (jsonData.error == null) {
      if (jsonData.command != null || jsonData.command !== undefined) {
        return
      }
      if (jsonData.type != null || jsonData.type !== undefined) {
        return
      } else {
        paymentResponse = JSON.stringify(jsonData)
      }
      if (jsonData.token == null || jsonData.token === "") {
        IsCreditCheckDone = false
        if (pageloaded === true) {
          document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML =
            "Please check your payment information again and re-submit for validation."
        }
        return
      }

      if (jsonData.routingNumber == null || jsonData.routingNumber === "") {
        document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML = ""
        IsCreditCheckDone = true
        // credit card
        document.getElementById("iBNMSG").innerHTML = ""
        document.getElementById("ICCMSG").innerHTML = "Thank you, your card information is approved."
        iFrameCreditCardNo = jsonData.cardNumber
        iFrameCreditaccountName = jsonData.accountName
        iFrameCreditcardExpDate = jsonData.cardExpDate
        IFrameCreditcardToken = jsonData.token
        IFrameCreditcardType = jsonData.cardType
        _IFrameCreditamount = jsonData.amount
        _IFrameCreditcardOperation = jsonData.operation
        IFrameCreditcardsource = jsonData.source
        IFrameCreditcardsource = IFrameCreditcardsource.toUpperCase()
        iFrameCreditcardExpFullDate = getExpiryDateWithLastDay(iFrameCreditcardExpDate)
        iFrameCreditcardExpFullDateIso = getExpiryDateWithISO(iFrameCreditcardExpDate)
      } else {
        document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML = ""
        IsCreditCheckDone = true
        // bank
        document.getElementById("ICCMSG").innerHTML = ""
        document.getElementById("iBNMSG").innerHTML = "Thank you, your bank information is approved."
        iFrameRoutingNo = jsonData.routingNumber
        iFrameaccountNumber = jsonData.accountNumber
        iFrameaccountName = jsonData.accountName
        iFrameaccountType = jsonData.accountType
        _iFrameBankamount = jsonData.amount
        iFrameBanktoken = jsonData.token
        _iFrameBankoperation = jsonData.operation
        iFrameBanksource = jsonData.source
        iFrameBanksource = iFrameBanksource.toUpperCase()
      }
    } else {
      IsCreditCheckDone = false
      paymentResponse = JSON.stringify(jsonData)
    }
  })

  async function validateForm() {
__ea_trace("modules/consent/consent-il-pay.ts","validateForm",[],[]);
    openProgressBar("We are saving your payment information")
    document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML = ""
    var paymentChecked = false
    var paymentTypeElements = document.querySelectorAll("#page_3_payment_required_consent_widget .paymentType")
    var selectedPaymentType
    for (var i = 0; i < paymentTypeElements.length; i++) {
      if (paymentTypeElements[i].checked) {
        paymentChecked = true
        selectedPaymentType = paymentTypeElements[i].value
        break
      }
    }
    if (paymentChecked === false) {
      document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML =
        "Please select at least one payment type."
      closeProgressBar()
    } else {
      document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML = ""
    }
    if (typeof selectedPaymentType === "undefined") {
      document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML =
        "Please select at least one payment type."
      closeProgressBar()
    } else {
      document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML = ""

      if (selectedPaymentType === "ACH") {
        if (IsCreditCheckDone === false) {
          document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML =
            "Please add payment information."
          closeProgressBar()
          return
        } else {
          document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML = ""
        }

        await addBankDataToDealRecord(selectedPaymentType)
      } else if (selectedPaymentType === "Credit Card") {
        if (IsCreditCheckDone === false) {
          closeProgressBar()
          document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML =
            "Please add payment information."
          return
        } else {
          document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML = ""
        }

        await addCreditCardDataToDealRecord(selectedPaymentType)
      }
    }
  }
  function showContent(type) {
__ea_trace("modules/consent/consent-il-pay.ts","showContent",[type],["type"]);
    document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML = ""
    document.querySelector("#page_3_payment_required_consent_widget .jnpiays-bank-details").style.display = "none"
    document.querySelector("#page_3_payment_required_consent_widget .jnpiays-credit-details").style.display = "none"
    document.querySelector(`#page_3_payment_required_consent_widget .jnpiays-${type}-details`).style.display = "block"
  }

  async function delay(ms) {
__ea_trace("modules/consent/consent-il-pay.ts","delay",[ms],["ms"]);
    return new Promise((resolve) => setTimeout(resolve, ms))
  }

  /* --------------------------------------------------- dcrypted password on submit stage ------------------------------------------------------ */
  var pwd
  var upwd
  function dp(val) {
__ea_trace("modules/consent/consent-il-pay.ts","dp",[val],["val"]);
    pwd = crypt.decrypt(val)
  }
  function dup(val) {
__ea_trace("modules/consent/consent-il-pay.ts","dup",[val],["val"]);
    upwd = crypt.decrypt(val)
  }
  async function getLoginPass() {
__ea_trace("modules/consent/consent-il-pay.ts","getLoginPass",[],[]);
    openProgressBar("We are securing all of your finalized data.")
    var email = storage.rawGet("userEmail")
    var catchdata = ""
    try {
      const data = {
        email: email,
      }
      const response = await fetch(apiUrl("GetContactRecordBasedOnEmail"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)
      const pr = dataa.userValue.properties.password
      dp(pr)
      if (dataa.message === "No User Found") {
      } else if (dataa.message === "User Found") {
        if (pwd !== "") {
          if (pr !== pwd) {
            await FPUpdatePassword(email, pwd)
          }
        }
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function FPUpdatePassword(email, pwd) {
__ea_trace("modules/consent/consent-il-pay.ts","FPUpdatePassword",[email,pwd],["email","pwd"]);
    var catchdata = ""
    try {
      const data = {
        properties: {
          email: email,
          password: pwd,
        },
      }
      const response = await fetch(apiUrl("UpdateContactRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function GetUtilityPass() {
__ea_trace("modules/consent/consent-il-pay.ts","GetUtilityPass",[],[]);
    var dealId = storage.rawGet("dealId")
    var catchdata = ""
    try {
      const data = {
        deal_id: dealId,
      }
      const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)

      if (dataa.message === "User Found") {
        var utps = dataa.userValue.properties.utility_password
        if (utps != null && utps !== "" && utps !== "null") {
          dup(utps)
        }
        if (upwd !== "" && upwd != null && upwd !== "null") {
          await updateUtilityPassword(upwd)
        }
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function updateUtilityPassword(pwd) {
__ea_trace("modules/consent/consent-il-pay.ts","updateUtilityPassword",[pwd],["pwd"]);
    var dealId = storage.rawGet("dealId")
    var catchdata = ""
    try {
      const data = {
        properties: {
          deal_id: dealId,
          utility_password: pwd,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
  }
  /* --------------------------------------------------- dcrypted password on submit stage ------------------------------------------------------ */

  async function addBankDataToDealRecord(selectedPaymentType) {
__ea_trace("modules/consent/consent-il-pay.ts","addBankDataToDealRecord",[selectedPaymentType],["selectedPaymentType"]);
    if (iFrameaccountType === "PC") {
      iFrameaccountType = "Personal Checking"
    } else if (iFrameaccountType === "PS") {
      iFrameaccountType = "Personal Savings"
    } else if (iFrameaccountType === "BC") {
      iFrameaccountType = "Business Checking"
    } else if (iFrameaccountType === "BS") {
      iFrameaccountType = "Business Savings"
    } else if (iFrameaccountType === "GL") {
      iFrameaccountType = "General Ledger"
    }
    var dealId = storage.rawGet("dealId")
    var _catchdata = ""
    try {
      openProgressBar("We are saving your payment information.")
      const data = {
        properties: {
          deal_id: dealId,
          ach_name: iFrameaccountName,
          ach_rout_number: iFrameRoutingNo,
          ach_account_number: iFrameaccountNumber,
          ach_account_type: iFrameaccountType,
          wallet_token: iFrameBanktoken,
          payment_vendor: iFrameBanksource,
          ach_user_auth: "true",
          payment_method: selectedPaymentType,
          cc_name: "",
          cc_last_4: "",
          cc_exp: "",
          cc_exp_date: "",
          token_expiration_date: "",
          cc_user_auth: "",
          card_type: "",
          payment_response: paymentResponse,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      _catchdata = data
      if (response.ok) {
        updateDealStage("984278689")
        storage.rawSet("typ", "lMiAsTaNc")
        await getLoginPass()
        await GetUtilityPass()

        await delay(10000)
        closeProgressBar()
        window.location.href = "/thank-you"
      }

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
      if (response.status === 500 || response.status === 404) {
        closeProgressBar()
      }
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
  }
  async function addCreditCardDataToDealRecord(selectedPaymentType) {
__ea_trace("modules/consent/consent-il-pay.ts","addCreditCardDataToDealRecord",[selectedPaymentType],["selectedPaymentType"]);
    var dealId = storage.rawGet("dealId")
    var _catchdata = ""
    try {
      openProgressBar("We are saving your payment information.")
      const data = {
        properties: {
          deal_id: dealId,
          payment_method: selectedPaymentType,
          cc_name: iFrameCreditaccountName,
          cc_last_4: iFrameCreditCardNo,
          cc_exp: iFrameCreditcardExpDate,
          cc_exp_date: iFrameCreditcardExpFullDate,
          token_expiration_date: iFrameCreditcardExpFullDateIso,
          cc_user_auth: "true",
          card_type: IFrameCreditcardType,
          wallet_token: IFrameCreditcardToken,
          payment_vendor: IFrameCreditcardsource,
          ach_name: "",
          ach_rout_number: "",
          ach_account_number: "",
          ach_account_type: "",
          ach_user_auth: "",
          payment_response: paymentResponse,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      _catchdata = data
      if (response.ok) {
        updateDealStage("984278689")
        storage.rawSet("typ", "lMiAsTaNc")
        await getLoginPass()
        await GetUtilityPass()

        await delay(10000)
        closeProgressBar()
        window.location.href = "/thank-you"
      }

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
      if (response.status === 500 || response.status === 404) {
        closeProgressBar()
      }
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
  }
  async function finalStepForNoPaymentMethod() {
__ea_trace("modules/consent/consent-il-pay.ts","finalStepForNoPaymentMethod",[],[]);
    var _dealId = storage.rawGet("dealId")
    openProgressBar("We are saving your information.")
    updateDealStage("984278689")
    storage.rawSet("typ", "lMiAsTaNc")
    await getLoginPass()
    await GetUtilityPass()
    await delay(10000)
    closeProgressBar()
    window.location.href = "/thank-you"
  }

  // save my place to deal record --------------------------------------------------------------------
  async function saveBankDataToDealRecord(selectedPaymentType) {
__ea_trace("modules/consent/consent-il-pay.ts","saveBankDataToDealRecord",[selectedPaymentType],["selectedPaymentType"]);
    var softCheck = document.querySelector("#page_3_payment_required_consent_widget #softCheck")
    if (!softCheck.checked) {
      softCheck = false
    } else {
      softCheck = true
    }
    if (iFrameaccountType === "PC") {
      iFrameaccountType = "Personal Checking"
    } else if (iFrameaccountType === "PS") {
      iFrameaccountType = "Personal Savings"
    } else if (iFrameaccountType === "BC") {
      iFrameaccountType = "Business Checking"
    } else if (iFrameaccountType === "BS") {
      iFrameaccountType = "Business Savings"
    } else if (iFrameaccountType === "GL") {
      iFrameaccountType = "General Ledger"
    }
    var dealId = storage.rawGet("dealId")
    var catchdata = ""
    try {
      const data = {
        properties: {
          deal_id: dealId,
          ach_name: iFrameaccountName,
          ach_rout_number: iFrameRoutingNo,
          ach_account_number: iFrameaccountNumber,
          ach_account_type: iFrameaccountType,
          wallet_token: iFrameBanktoken,
          payment_vendor: iFrameBanksource,
          ach_user_auth: "true",
          payment_method: selectedPaymentType,
          credit_check_agreement: softCheck,
          cc_name: "",
          cc_last_4: "",
          cc_exp: "",
          cc_exp_date: "",
          token_expiration_date: "",
          cc_user_auth: "",
          card_type: "",
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function saveCreditCardDataToDealRecord(selectedPaymentType) {
__ea_trace("modules/consent/consent-il-pay.ts","saveCreditCardDataToDealRecord",[selectedPaymentType],["selectedPaymentType"]);
    var softCheck = document.querySelector("#page_3_payment_required_consent_widget #softCheck")
    if (!softCheck.checked) {
      softCheck = false
    } else {
      softCheck = true
    }
    var dealId = storage.rawGet("dealId")
    var catchdata = ""
    try {
      const data = {
        properties: {
          deal_id: dealId,
          payment_method: selectedPaymentType,
          cc_name: iFrameCreditaccountName,
          cc_last_4: iFrameCreditCardNo,
          cc_exp: iFrameCreditcardExpDate,
          cc_user_auth: "true",
          card_type: IFrameCreditcardType,
          wallet_token: IFrameCreditcardToken,
          payment_vendor: IFrameCreditcardsource,
          credit_check_agreement: softCheck,
          ach_name: "",
          ach_rout_number: "",
          ach_account_number: "",
          ach_account_type: "",
          ach_user_auth: "",
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function _savediscluserandagreementdata() {
__ea_trace("modules/consent/consent-il-pay.ts","_savediscluserandagreementdata",[],[]);
    var softCheck = document.querySelector("#page_3_payment_required_consent_widget #softCheck")
    if (!softCheck.checked) {
      softCheck = false
    } else {
      softCheck = true
    }
    var dealId = storage.rawGet("dealId")
    var catchdata = ""
    try {
      const data = {
        properties: {
          deal_id: dealId,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
  }
  function saveForm() {
__ea_trace("modules/consent/consent-il-pay.ts","saveForm",[],[]);
    var paymentTypeElements = document.querySelectorAll("#page_3_payment_required_consent_widget .paymentType")
    var selectedPaymentType
    for (var i = 0; i < paymentTypeElements.length; i++) {
      if (paymentTypeElements[i].checked) {
        selectedPaymentType = paymentTypeElements[i].value
        break
      }
    }
    document.querySelector("#page_3_payment_required_consent_widget #paymentType_error_message").innerHTML = ""
    var _checkbox = document.querySelector("#page_3_payment_required_consent_widget #softCheck")
    if (selectedPaymentType === "ACH") {
      saveBankDataToDealRecord(selectedPaymentType)
    } else if (selectedPaymentType === "Credit Card") {
      saveCreditCardDataToDealRecord(selectedPaymentType)
    }
  }
  document.querySelector("#page_3_payment_required_consent_widget #save-remind").addEventListener("click", saveForm)
  // save my place to deal record --------------------------------------------------------------------

  async function _getSignPdfUrl(_value) {
__ea_trace("modules/consent/consent-il-pay.ts","_getSignPdfUrl",[_value],["_value"]);
    var email = storage.rawGet("userEmail")
    var _formId = storage.rawGet("formId")
    var formPdf = storage.rawGet("formPdf")
    var fullName = storage.rawGet("LoggedName")
    var dealId = storage.rawGet("dealId")
    var projectName = `${fullName} ${dealId}`
    try {
      const data = {
        properties: {
          pdfData: formPdf,
          pdfName: projectName,
          email: email,
        },
      }
      const _response = await fetch("https://api.nautilussolar.com/getSign", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
    } catch (error) {
      console.error("Error:", error)
    }
    return true
  }
  async function updateAgreementId(value, property) {
__ea_trace("modules/consent/consent-il-pay.ts","updateAgreementId",[value,property],["value","property"]);
    var dealId = storage.rawGet("dealId")
    try {
      if (property === "subscription_adobe_agreement_id") {
        var _prop = {
          properties: {
            deal_id: dealId,
            subscription_adobe_agreement_id: value,
          },
        }
      } else {
        var prop = {
          properties: {
            deal_id: dealId,
            adobe_agreement_id: value,
          },
        }
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(prop),
      })

      if (response.ok) {
        closeProgressBar()
      }
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
    return true
  }
  async function sendBase64Toserverless(_esignUrl, agreementId) {
__ea_trace("modules/consent/consent-il-pay.ts","sendBase64Toserverless",[_esignUrl,agreementId],["_esignUrl","agreementId"]);
    var esignUrl = esignUrl
    storage.rawSet("agreementId", agreementId)
    await updateAgreementId(agreementId)
    document.querySelector(".discPdf").style.display = "none"
    document.querySelector("#proccedToSign").style.display = "none"
    var _embedUrl =
      "https://secure.na3.echosign.com/public/esign?aid=CBFCIBAACBSCTBABDUAAABACAABAAjeGj9VqtIuatY0flLymiWiUNCLKWksfSOcrZ6orGqHw2nDxT9m3i58pfkR0NPNCQGu2GxY5UP4FvTuQqfq0WmRkRptCghP48V-ydRlfzd7o%2A&client_id=CBJCHBCAABAAIRL7G0r6fFEHJYHGwURf9LKvCycWBeI0"
    document.querySelector("#signPdf").src = esignUrl
    document.querySelector("#signPdfTitle").style.display = "block"
    document.querySelector("#signPdf").style.display = "block"
    document.querySelector("#page_3_payment_required_consent_widget #thirdStepButton").style.display = "none"
    document.querySelector("#page_3_payment_required_consent_widget #secondStepButton").style.display = "none"
    document.querySelector("#page_3_payment_required_consent_widget #firstStepButton").style.display = "block"
    closeProgressBar()
  }
  async function sendAgreementIdToGetStatus() {
__ea_trace("modules/consent/consent-il-pay.ts","sendAgreementIdToGetStatus",[],[]);
    var _dealId = storage.rawGet("dealId")
    var agreementId = storage.rawGet("agreementId")
    try {
      const hubDBEndpoint = `https://api.nautilussolar.com/api/agreementstatus/${agreementId}`
      const response = await fetch(hubDBEndpoint, { method: "GET" })
      const res = await response.json()

      if (res.data.status === "OUT_FOR_SIGNATURE") {
        alert("Please sign the agreement to proceed.")
        closeProgressBar()
      } else if (res.data.status === "SIGNED") {
        document.querySelector("#page_3_payment_required_consent_widget .secondWidget").classList.add("active")
        document.querySelector("#page_3_payment_required_consent_widget .firstWidget").classList.remove("active")
        document.querySelector("#page_3_payment_required_consent_widget #thirdStepButton").style.display = "none"
        document.querySelector("#page_3_payment_required_consent_widget #secondStepButton").style.display = "none"
        document.querySelector("#page_3_payment_required_consent_widget #firstStepButton").style.display = "none"
        document.querySelector("#page_3_payment_required_consent_widget #goback-personal-info").style.display = "none"
        document.querySelector("#page_3_payment_required_consent_widget #gobackToFirstStep").style.display = "block"
        document.querySelector("#page_3_payment_required_consent_widget #gobackToSecondStep").style.display = "none"

        await uploadDisclosurePDF(res.hubspot.url, res.hubspot.id)
      } else {
        alert("Please sign the agreement to proceed.")
        closeProgressBar()
      }
    } catch (error) {
      closeProgressBar()
      console.error("Error in Usage hubdb fetch block:", error)
    }
  }

  document.querySelector("#page_3_payment_required_consent_widget #gobackToFirstStep").addEventListener("click", () => {
__ea_trace("modules/consent/consent-il-pay.ts","(anon)",[],[]);
    document.querySelector("#page_3_payment_required_consent_widget #gobackToFirstStep").style.display = "none"
    document.querySelector("#page_3_payment_required_consent_widget #goback-personal-info").style.display = "block"
    document.querySelector(".secondWidget").classList.remove("active")
    document.querySelector(".firstWidget").classList.add("active")
    document.querySelector("#page_3_payment_required_consent_widget #secondStepButton").style.display = "none"
    document.querySelector("#page_3_payment_required_consent_widget #firstStepButton").style.display = "block"
  })

  async function sendSubAgreementIdToGetStatus() {
__ea_trace("modules/consent/consent-il-pay.ts","sendSubAgreementIdToGetStatus",[],[]);
    var _dealId = storage.rawGet("dealId")
    var subagreementId = storage.rawGet("SubagreementId")
    try {
      const hubDBEndpoint = `https://api.nautilussolar.com/api/agreementstatus/${subagreementId}`
      const response = await fetch(hubDBEndpoint, { method: "GET" })
      const res = await response.json()

      if (res.data.status === "OUT_FOR_SIGNATURE") {
        alert("Please sign the agreement to proceed.")
        closeProgressBar()
      } else if (res.data.status === "SIGNED") {
        if (storage.rawGet("rp") !== "NpEv") {
          openProgressBar("We are loading your payment options")
          document.querySelector("#page_3_payment_required_consent_widget .thirdWidget").classList.add("active")
          document.querySelector("#page_3_payment_required_consent_widget .thirdWidget").style.display = "block"
          document.querySelector("#page_3_payment_required_consent_widget #thirdStepButton").style.display = "block"
          document.querySelector("#page_3_payment_required_consent_widget .secondWidget").classList.remove("active")
          document.querySelector("#page_3_payment_required_consent_widget #secondStepButton").style.display = "none"
        } else {
          document.querySelector("#page_3_payment_required_consent_widget .thirdWidget").classList.remove("active")
          document.querySelector("#page_3_payment_required_consent_widget .thirdWidget").style.display = "none"
          document.querySelector("#page_3_payment_required_consent_widget #thirdStepButton").style.display = "none"
        }
        document.querySelector("#page_3_payment_required_consent_widget #firstStepButton").style.display = "none"
        document.querySelector("#page_3_payment_required_consent_widget #goback-personal-info").style.display = "none"
        document.querySelector("#page_3_payment_required_consent_widget #gobackToFirstStep").style.display = "none"
        document.querySelector("#page_3_payment_required_consent_widget #gobackToSecondStep").style.display = "block"
        await updateSubAdobeUrl(res.url, res.hubspot.url, res.hubspot.id)
        if (storage.rawGet("rp") === "NpEv") {
          await finalStepForNoPaymentMethod()
        }
      } else {
        alert("Please sign the agreement to proceed.")
        closeProgressBar()
      }
    } catch (error) {
      closeProgressBar()
      console.error("Error in Usage hubdb fetch block:", error)
    }
  }

  document
    .querySelector("#page_3_payment_required_consent_widget #gobackToSecondStep")
    .addEventListener("click", () => {
__ea_trace("modules/consent/consent-il-pay.ts","(anon)",[],[]);
      document.querySelector("#page_3_payment_required_consent_widget #gobackToFirstStep").style.display = "block"
      document.querySelector("#page_3_payment_required_consent_widget #gobackToSecondStep").style.display = "none"
      document.querySelector("#page_3_payment_required_consent_widget #thirdStepButton").style.display = "none"
      document.querySelector("#page_3_payment_required_consent_widget #secondStepButton").style.display = "block"
      document.querySelector(".thirdWidget").classList.remove("active")
      document.querySelector(".secondWidget").classList.add("active")
    })

  async function uploadDisclosurePDF(value, value1) {
__ea_trace("modules/consent/consent-il-pay.ts","uploadDisclosurePDF",[value,value1],["value","value1"]);
    var agreementId = storage.rawGet("agreementId")
    var formIddd = storage.rawGet("formId")
    var _catchdata = ""
    try {
      const data = {
        form_id: formIddd,
        form_type: "signed_form",
        doc_signed_form_ext: "pdf",
        agreementId: agreementId,
      }
      const response = await fetch(`https://api.nautilussolar.com/api/${endprodORsbx}/uploadDisclosurePDF`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      //             catchdata = data;
      if (response.ok) {
        const result = await response.json()

        if (result.url !== undefined && result.url != null) {
          await updateAdobeUrl(result.url, value, value1)
        }
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function _uploadSubagreementPDF() {
__ea_trace("modules/consent/consent-il-pay.ts","_uploadSubagreementPDF",[],[]);
    var agreementId = storage.rawGet("agreementId")
    var formIddd = storage.rawGet("formId")
    var _catchdata = ""
    try {
      const data = {
        form_id: formIddd,
        form_type: "signed_form",
        doc_signed_form_ext: "pdf",
        agreementId: agreementId,
      }
      const response = await fetch(`https://api.nautilussolar.com/api/${endprodORsbx}/uploadDisclosurePDF`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      if (response.ok) {
        const result = await response.json()

        if (result.url !== undefined && result.url != null) {
          await updateAdobeUrl(result.url, result.hbFileURL)
        }
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }

  document
    .querySelector("#page_3_payment_required_consent_widget #firstStepButton")
    .addEventListener("click", async () => {
__ea_trace("modules/consent/consent-il-pay.ts","(anon)",[],[]);
      openProgressBar("We are saving your signed document to your account")
      await sendAgreementIdToGetStatus()
    })
  document
    .querySelector("#page_3_payment_required_consent_widget #thirdStepButton")
    .addEventListener("click", validateForm)
  document
    .querySelector("#page_3_payment_required_consent_widget #proccedToSign")
    .addEventListener("click", async () => {
__ea_trace("modules/consent/consent-il-pay.ts","(anon)",[],[]);})

  async function updateFormId(value, formStatus, espfy, ebcfy, ebcfyv2, tsfy, _res, esignUrl, agreementId) {
__ea_trace("modules/consent/consent-il-pay.ts","updateFormId",[value,formStatus,espfy,ebcfy,ebcfyv2,tsfy,_res,esignUrl,agreementId],["value","formStatus","espfy","ebcfy","ebcfyv2","tsfy","_res","esignUrl","agreementId"]);
    var dealId = storage.rawGet("dealId")
    try {
      const prop = {
        properties: {
          deal_id: dealId,
          il_formid: value,
          total_saving_first_year: tsfy,
          il_formstatus: formStatus,
          estimated_subscription_payment_first_year: espfy,
          estimated_bill_credits_first_year: ebcfy,
          estimated_bill_credits_first_year_v2: ebcfyv2,
          //                     create_disclosure_response: res
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(prop),
      })

      if (response.ok) {
        await GetAgreementIdFromDeal(esignUrl, agreementId)
      }
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
    return true
  }
  async function updateAdobeUrl(_value, value1, value2) {
__ea_trace("modules/consent/consent-il-pay.ts","updateAdobeUrl",[_value,value1,value2],["_value","value1","value2"]);
    var dealId = storage.rawGet("dealId")
    try {
      const prop = {
        properties: {
          deal_id: dealId,
          il_disclosure_signed_file: value1,
          saa_document_sub_type_1: utilityDetails["76"][0].label,
          lmi_saa_doc_file_1: value1,
          il_disclosure_signed_file_id: value2,
          saa_doc_file_1_id: value2,
          dealstage: "984278687",
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(prop),
      })

      if (response.ok) {
        await GetSubAgreementIdFromDeal()
      }
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
    return true
  }
  async function updateSubAdobeUrl(_value, value1, value2) {
__ea_trace("modules/consent/consent-il-pay.ts","updateSubAdobeUrl",[_value,value1,value2],["_value","value1","value2"]);
    var dealId = storage.rawGet("dealId")
    try {
      const prop = {
        properties: {
          deal_id: dealId,
          saa_document_sub_type_2: utilityDetails["75"][0].label,
          il_subscription_signed_file: value1,
          lmi_saa_doc_file_2: value1,
          il_subscription_signed_file_id: value2,
          saa_doc_file_2_id: value2,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(prop),
      })

      if (response.ok) {
        closeProgressBar()
      }

      const _result = await response.json()
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
    return true
  }
  async function updateDealStage(value) {
__ea_trace("modules/consent/consent-il-pay.ts","updateDealStage",[value],["value"]);
    if (value == null || value === undefined || value === "") {
      value = "984278686"
    } else if (value === "984278689") {
      storage.rawSet("DealStage", "Submitted")
    }
    var dealId = storage.rawGet("dealId")
    try {
      const prop = {
        properties: {
          deal_id: dealId,
          dealstage: value,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(prop),
      })

      if (response.ok) {
      }
    } catch (error) {
      console.error("Error:", error)
    }
    return true
  }

  async function getAgreementUrl(adobe_agreement_id) {
__ea_trace("modules/consent/consent-il-pay.ts","getAgreementUrl",[adobe_agreement_id],["adobe_agreement_id"]);
    try {
      const hubDBEndpoint = `https://api.nautilussolar.com/api/getSignatureUrl/${adobe_agreement_id}`
      const response = await fetch(hubDBEndpoint, { method: "GET" })
      const result = await response.json()

      if (result.data.code === "AGREEMENT_NOT_SIGNABLE") {
        alert("Disclosure Agreement already signed")
        document.querySelector("#page_3_payment_required_consent_widget .secondWidget").classList.add("active")
        document.querySelector("#page_3_payment_required_consent_widget .firstWidget").classList.remove("active")
        document.querySelector("#page_3_payment_required_consent_widget #goback-personal-info").style.display = "none"
        document.querySelector("#page_3_payment_required_consent_widget #gobackToFirstStep").style.display = "block"
        document.querySelector("#page_3_payment_required_consent_widget #gobackToSecondStep").style.display = "none"
        await sendAgreementIdToGetStatus()
      } else {
        var esignUrl = result.data.signingUrlSetInfos[0].signingUrls[0].esignUrl
        var agreementId = result.agreementId
        storage.rawSet("agreementId", agreementId)
        document.querySelector(".discPdf").style.display = "none"
        document.querySelector("#proccedToSign").style.display = "none"
        var _embedUrl =
          "https://secure.na3.echosign.com/public/esign?aid=CBFCIBAACBSCTBABDUAAABACAABAAjeGj9VqtIuatY0flLymiWiUNCLKWksfSOcrZ6orGqHw2nDxT9m3i58pfkR0NPNCQGu2GxY5UP4FvTuQqfq0WmRkRptCghP48V-ydRlfzd7o%2A&client_id=CBJCHBCAABAAIRL7G0r6fFEHJYHGwURf9LKvCycWBeI0"
        document.querySelector("#signPdf").src = esignUrl
        document.querySelector("#signPdfTitle").style.display = "block"
        document.querySelector("#signPdf").style.display = "block"
        //                 document.querySelector('#page_3_payment_required_consent_widget #get-utility-info').classList.add('firstStepButton');
        document.querySelector("#page_3_payment_required_consent_widget #thirdStepButton").style.display = "none"
        document.querySelector("#page_3_payment_required_consent_widget #secondStepButton").style.display = "none"
        document.querySelector("#page_3_payment_required_consent_widget #firstStepButton").style.display = "block"
        closeProgressBar()
      }
    } catch (error) {
      closeProgressBar()
      console.error("Error in Usage hubdb fetch block:", error)
    }
  }
  async function getSubAgreementUrl(adobe_agreement_id) {
__ea_trace("modules/consent/consent-il-pay.ts","getSubAgreementUrl",[adobe_agreement_id],["adobe_agreement_id"]);
    try {
      const hubDBEndpoint = `https://api.nautilussolar.com/api/getSignatureUrl/${adobe_agreement_id}`
      const response = await fetch(hubDBEndpoint, { method: "GET" })
      const result = await response.json()

      if (result.data.code === "AGREEMENT_NOT_SIGNABLE") {
        alert("Subscription Agreement already signed")
        if (storage.rawGet("rp") !== "NpEv") {
          openProgressBar("We are loading your payment options")
          document.querySelector("#page_3_payment_required_consent_widget .thirdWidget").classList.add("active")
          document.querySelector("#page_3_payment_required_consent_widget .thirdWidget").style.display = "block"
          document.querySelector("#page_3_payment_required_consent_widget #thirdStepButton").style.display = "block"
        } else {
          document.querySelector("#page_3_payment_required_consent_widget .thirdWidget").classList.remove("active")
          document.querySelector("#page_3_payment_required_consent_widget .thirdWidget").style.display = "none"
          document.querySelector("#page_3_payment_required_consent_widget #thirdStepButton").style.display = "none"
        }
        document.querySelector("#page_3_payment_required_consent_widget .secondWidget").classList.remove("active")
        document.querySelector("#page_3_payment_required_consent_widget #secondStepButton").style.display = "none"
        document.querySelector("#page_3_payment_required_consent_widget #firstStepButton").style.display = "none"
        document.querySelector("#page_3_payment_required_consent_widget #goback-personal-info").style.display = "none"
        document.querySelector("#page_3_payment_required_consent_widget #gobackToFirstStep").style.display = "none"
        document.querySelector("#page_3_payment_required_consent_widget #gobackToSecondStep").style.display = "block"
        if (storage.rawGet("rp") === "NpEv") {
          await finalStepForNoPaymentMethod()
        }
      } else {
        await sendSubAgreementBase64Toserverless()
      }
      closeProgressBar()
    } catch (error) {
      closeProgressBar()
      console.error("Error in Usage hubdb fetch block:", error)
    }
  }

  async function GetAgreementIdFromDeal(esignUrl, agreementId) {
__ea_trace("modules/consent/consent-il-pay.ts","GetAgreementIdFromDeal",[esignUrl,agreementId],["esignUrl","agreementId"]);
    var dealId = storage.rawGet("dealId")
    var _catchdata = ""
    try {
      const data = {
        deal_id: dealId,
      }
      const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      _catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)

      if (dataa.message === "User Found") {
        var adobe_agreement_id = dataa.userValue.properties.adobe_agreement_id

        if (adobe_agreement_id == null || adobe_agreement_id === "null" || adobe_agreement_id === "") {
          await sendBase64Toserverless(esignUrl, agreementId)
        } else {
          storage.rawSet("agreementId", adobe_agreement_id)
          await getAgreementUrl(adobe_agreement_id)
        }
      }
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
  }
  async function GetSubAgreementIdFromDeal() {
__ea_trace("modules/consent/consent-il-pay.ts","GetSubAgreementIdFromDeal",[],[]);
    openProgressBar("We are creating your subscription document")
    var dealId = storage.rawGet("dealId")
    var _catchdata = ""
    try {
      const data = {
        deal_id: dealId,
      }
      const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      _catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)

      if (dataa.message === "User Found") {
        var subscription_adobe_agreement_id = dataa.userValue.properties.subscription_adobe_agreement_id
        if (
          subscription_adobe_agreement_id == null ||
          subscription_adobe_agreement_id === "null" ||
          subscription_adobe_agreement_id === ""
        ) {
          await sendSubAgreementBase64Toserverless()
        } else {
          await getSubAgreementUrl(subscription_adobe_agreement_id)
        }
      }
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
  }
  // ------------- Get saved data -------------------------------

  function getMonthYearAfterSixMonths() {
__ea_trace("modules/consent/consent-il-pay.ts","getMonthYearAfterSixMonths",[],[]);
    const today = new Date()

    // Add 6 months to the current date
    const futureDate = new Date(today.getFullYear(), today.getMonth() + 4, 1)

    const year = futureDate.getFullYear()
    const month = String(futureDate.getMonth() + 1).padStart(2, "0") // months are 0-based

    return `${year}-${month}`
  }

  var estimatedMonthAndyear = getMonthYearAfterSixMonths()

  // The Illinois subscription agreement is a versioned HTML asset. Its
  // values come from the deal record, so the load waits on this promise;
  // GetDataFromDealRecord settles it. The Android variant differs only in
  // page-break markup and is fetched only on Android.
  var resolveAgreementValues
  var rejectAgreementValues
  var agreementValuesReady = new Promise((resolve, reject) => {
__ea_trace("modules/consent/consent-il-pay.ts","(anon)",[resolve,reject],["resolve","reject"]);
    resolveAgreementValues = resolve
    rejectAgreementValues = reject
  })

  var isAndroidDevice = /Android/i.test(navigator.userAgent)

  async function sendDatatoCreateDisclouser(_val, _rndNum) {
__ea_trace("modules/consent/consent-il-pay.ts","sendDatatoCreateDisclouser",[_val,_rndNum],["_val","_rndNum"]);
    const myHeaders = new Headers()
    myHeaders.append("Content-Type", "application/json")
    myHeaders.append("templateid", "CBJCHBCAABAA9Cl5aBHMR70YPZRYpG0jdczST5KNyJR7")

    var fullName = storage.rawGet("LoggedName")
    var _dealId = storage.rawGet("dealId")
    var projectName = ""
    var randomnum = Date.now()
    projectName = `${fullName} ${randomnum}`
    var UtilitySessionDetails = JSON.parse(storage.rawGet("UtilitySessionDetails"))
    var zipCode = storage.rawGet("zip_code")
    var _FarmCity = storage.rawGet("FarmCity")
    var City = storage.rawGet("city")
    var _UanNumber = storage.rawGet("UanNumber")
    var userEmail = storage.rawGet("userEmail")
    myHeaders.append("email", userEmail)
    myHeaders.append("pdfname", projectName)
    var CellPhone = storage.rawGet("CellPhone")
    var HomePhone = storage.rawGet("HomePhone")
    if (CellPhone == null || CellPhone === "" || CellPhone === undefined) {
      CellPhone = HomePhone
    }
    var combinedNumber = storage.rawGet("combined_utility_account_number")
    var acNumbers = storage.rawGet("uan1Value")
    if (storage.rawGet("utility_id") === "COMED-SF") {
      acNumbers = `${storage.rawGet("uan1Value")}-${storage.rawGet("uan2Value")}`
    } else {
      acNumbers = storage.rawGet("uan1Value")
    }
    if (acNumbers === undefined || acNumbers === "undefined" || acNumbers === "null" || acNumbers == null) {
      acNumbers = ""
    }
    var streetaddress = storage.rawGet("street_address")
    var streetaddress2 = storage.rawGet("street_address_2")
    if (combinedNumber === undefined || combinedNumber === "undefined") {
      combinedNumber = ""
    }
    if (
      streetaddress === undefined ||
      streetaddress === "undefined" ||
      streetaddress == null ||
      streetaddress === "null"
    ) {
      streetaddress = ""
    }
    if (
      streetaddress2 === undefined ||
      streetaddress2 === "undefined" ||
      streetaddress2 == null ||
      streetaddress2 === "null"
    ) {
      streetaddress2 = ""
    }
    var gross_electricity_production = storage.rawGet("gross_electricity_production")
    var _payment_amount_per_kwh = storage.rawGet("payment_amount_per_kwh")
    var subscription_size_kWAC = storage.rawGet("subscription_size_kWAC")

    var paymentPercentageOfCsCredits = 0
    var isLMI = storage.rawGet("isLMI")
    var incomeThreeShold = storage.rawGet("incomeThreesholdOp")
    if (isLMI === "Yes" && incomeThreeShold !== "Yes") {
      paymentPercentageOfCsCredits = 80
    } else if (isLMI !== "Yes" || incomeThreeShold === "Yes") {
      paymentPercentageOfCsCredits = 90
    }
    try {
      const data = {
        name_1: "Credit Card Fee",
        amount_1: "2.90%",
        form_type: "csf_form",
        vendor_id: 2177,
        Spanish_PDF: "No",
        start_month: estimatedMonthAndyear,
        terms_years: 20,
        invoice_type: "Electronic",
        project_name: projectName, //dynamic
        require_ARES: "no",
        terms_months: 1,
        initial_amount: "0",
        payment_method: "ACH",
        payment_formula: null,
        electric_utility: UtilitySessionDetails["11"], //dynamic (Utility_ID_3 we are getting from Session Config)
        termination_circ:
          "Required to pay any outstanding balances, and termination could take up to 90 days to complete.",
        payment_frequency: "Monthly, within 60 days after energization",
        subscription_type: "% of Community solar credits on the utility bill",
        when_applicable_1: "Applicable for Credit Card Payments",
        initial_supply_rate: null,
        is_autopay_required: "Yes",
        supply_rate_formula: null,
        termination_penalty: "No",
        payment_percentage_of_cs_credits: paymentPercentageOfCsCredits,
        annual_escalation_rate: null,
        auto_esign_email_optin: "No",
        nearest_inhabited_area: City,
        provider_address_email: "customercare@nautilussolar.com",
        provider_address_phone: "8669694129",
        subscriber_address_zip: zipCode, //dynamic
        subscription_size_kWAC: subscription_size_kWAC,
        explanatory_information: null,
        minimum_level_guarantee: "no",
        sub_utility_acct_number: acNumbers, //dynamic (Combined Utility Account Number)
        subscriber_address_city: City, //dynamic
        termination_application: null,
        provider_address_website: "www.nautilussolar.com",
        subscriber_address_email: userEmail, //dynamic
        subscriber_address_phone: CellPhone, //dynamic
        subscriber_address_state: "IL", //dynamic
        provider_address_dba_name: "Nautilus Community Solar, LLC",
        // "expected_energization_date": "2019-01-04",
        subscriber_address_address1: streetaddress, //dynamic
        subscriber_address_address2: streetaddress2, //dynamic
        gross_electricity_production: gross_electricity_production,
        subscriber_address_attention: fullName, //dynamic
        provider_address_company_name: "Nautilus US Power Holdco, LLC",
        is_payment_through_utility_bill: "No",
        substitute_auto_esign_emailaddr: null,
        Is_cs_provider_required_to_be_utility_agent: "Yes",
        is_advanced_notice_required_for_termination: "No",
      }
      const response = await fetch(`https://api.nautilussolar.com/api/${endprodORsbx}/shortcut/getSignUrl`, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(data),
        redirect: "follow",
      })
      const resp = await response.json()
      var formId = resp.data.form_id
      var formStatus = resp.data.form_status
      var espfy = resp.data.estimated_subscription_payment_first_year
      var ebcfy = resp.data.estimated_bill_credits_first_year
      var ebcfyv2 = resp.data.estimated_bill_credits_first_year_v2
      var tsfy = resp.data.total_savings_first_year
      var esignUrl = resp.data.esignUrl
      var agreementId = resp.agreementId
      storage.rawSet("formId", formId)
      await updateFormId(formId, formStatus, espfy, ebcfy, ebcfyv2, tsfy, resp, esignUrl, agreementId)
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
    }
  }
  async function getDisclouserPdf(ilFormID) {
__ea_trace("modules/consent/consent-il-pay.ts","getDisclouserPdf",[ilFormID],["ilFormID"]);
    try {
      const hubDBEndpoint = `https://api.nautilussolar.com/api/${endprodORsbx}/getDisclosurePDF?FormID=${ilFormID}`
      const response = await fetch(hubDBEndpoint, { method: "GET" })
      const res = await response.json()
      var formIdd = res.messageDetails.form_id
      storage.rawSet("formId", formIdd)
      await GetAgreementIdFromDeal()
    } catch (error) {
      closeProgressBar()
      console.error("Error in Usage hubdb fetch block:", error)
    }
  }
  async function GetDataFromDealRecord() {
__ea_trace("modules/consent/consent-il-pay.ts","GetDataFromDealRecord",[],[]);
    openProgressBar("We are generating your consent documents")
    await updateDealStage()
    var dealId = storage.rawGet("dealId")
    var _catchdata = ""
    try {
      const data = {
        deal_id: dealId,
      }
      const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      _catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)
      if (dataa.message === "User Found") {
        var ilFormID = dataa.userValue.properties.il_formid
        var cuan = dataa.userValue.properties.combined_utility_account_number
        var street_address = dataa.userValue.properties.street_address

        var city = dataa.userValue.properties.city

        var street_address_2 = dataa.userValue.properties.street_address_2
        var utility_type = dataa.userValue.properties.utility_type
        var uan1val = dataa.userValue.properties.uan_1_value
        var uan2val = dataa.userValue.properties.uan_2_value
        storage.rawSet("uan1Value", uan1val)
        storage.rawSet("uan2Value", uan2val)

        storage.rawSet("combined_utility_account_number", cuan)
        storage.rawSet("street_address", street_address)
        storage.rawSet("street_address_2", street_address_2)
        storage.rawSet("tarrifType", utility_type)

        var Farm_StateAbbreviation = storage.rawGet("FarmStateAbbreviation")
        var zipCode = storage.rawGet("zip_code")
        var combinedUtilityAccountNumber = storage.rawGet("combined_utility_account_number")
        if (
          combinedUtilityAccountNumber === undefined ||
          combinedUtilityAccountNumber == null ||
          combinedUtilityAccountNumber === ""
        ) {
          combinedUtilityAccountNumber = cuan
        }
        var tarrifType = storage.rawGet("tarrifType")
        var gross_electricity_production = storage.rawGet("gross_electricity_production")
        var subscription_size_kWAC = storage.rawGet("subscription_size_kWAC")
        var estimatedAnnualEleCost = storage.rawGet("estimatedAnnualEleCost")
        var streetAddresss = storage.rawGet("street_address")

        gross_electricity_production = Math.floor(gross_electricity_production).toLocaleString()
        subscription_size_kWAC = Number(subscription_size_kWAC)
        subscription_size_kWAC = subscription_size_kWAC.toFixed(3)
        estimatedAnnualEleCost = Number(estimatedAnnualEleCost)
        estimatedAnnualEleCost =
          estimatedAnnualEleCost >= 1
            ? `$${estimatedAnnualEleCost.toFixed(2)}`
            : `${(estimatedAnnualEleCost * 100).toFixed(2)} cents`

        // The subscription agreement itself lives in
        // agreements/illinois/; hand it the values it renders.
        resolveAgreementValues({
          email: String(loggedEmail ?? ""),
          estimatedAnnualElectricityCost: String(estimatedAnnualEleCost ?? ""),
          grossElectricityProduction: String(gross_electricity_production ?? ""),
          primaryPhone: String(loggedCellPhone ?? loggedHomePhone ?? ""),
          serviceCity: String(city ?? ""),
          serviceState: String(Farm_StateAbbreviation ?? ""),
          serviceStreetAddress: String(streetAddresss ?? ""),
          serviceZip: String(zipCode ?? ""),
          signedDate: String(formattedDate2 ?? ""),
          subscriberName: String(loggedName ?? ""),
          subscriptionSizeKwAc: String(subscription_size_kWAC ?? ""),
          tariffType: String(tarrifType ?? ""),
          utilityAccountNumber: String(combinedUtilityAccountNumber ?? ""),
        })

        if (ilFormID == null || ilFormID === "null" || ilFormID === "") {
          await sendDatatoCreateDisclouser(true, "")
        } else {
          await getDisclouserPdf(ilFormID)
        }
      } else {
        // No values means no renderable agreement — surface it through
        // the readiness gate rather than producing a blank PDF.
        rejectAgreementValues(new Error("Deal record did not return the Illinois agreement values"))
      }
    } catch (error) {
      closeProgressBar()
      console.error("Error:", error)
      rejectAgreementValues(error)
    }
  }

  async function GetSubscriptionAndDisclosureFromSessionConfigTable() {
__ea_trace("modules/consent/consent-il-pay.ts","GetSubscriptionAndDisclosureFromSessionConfigTable",[],[]);
    var u_id = storage.rawGet("utility_id")
    try {
      const hubDBEndpoint = `https://api.hubapi.com/hubdb/api/v2/tables/${window.__ENV__.hubdb.utilityAvailability}/rows?portalId=${window.__ENV__.dataPortalId}&utility_id=${u_id}`
      const response = await fetch(hubDBEndpoint, { method: "GET" })
      const data = await response.json()
      var rows = data.objects
      if (rows.length >= 1) {
        var _disclosure = rows[0].values[65]
        var _subscriptionAgreement = rows[0].values[66]
      }
    } catch (error) {
      console.error("Error in Usage hubdb fetch block:", error)
    }
    await GetDataFromDealRecord()
  }
  GetSubscriptionAndDisclosureFromSessionConfigTable()

  // pdf and print ---------------------------------------------------------------------
  var loggedName = storage.rawGet("LoggedName")
  var _loggedAddress = storage.rawGet("Address")
  var loggedEmail = storage.rawGet("userEmail")
  var _loggedState = storage.rawGet("stateForLMIConfig")
  var _loggedZip = storage.rawGet("zip_code")
  var loggedHomePhone = storage.rawGet("HomePhone")
  var loggedCellPhone = storage.rawGet("CellPhone")
  var _loggedCounty = storage.rawGet("county") ?? ""

  var _Farm_LLC = storage.rawGet("FarmName")
  var _Farm_Project_Description = storage.rawGet("FarmProjectDescription")
  var _Farm_Phone_Number = storage.rawGet("FarmPhoneNumber")
  var _Farm_LLC_Address1 = storage.rawGet("FarmStreetAddress1")

  var _Farm_LLC_Address2 = ""
  var _Farm_LLC_City = ""
  var _Farm_LLC_State = ""
  var _Farm_LLC_Zip = ""
  var _Farm_LLC_Email = ""
  var _Farm_LLC_Id = ""
  var _Farm_Display_Name = ""

  if (storage.rawGet("HomePhone") === undefined || storage.rawGet("HomePhone") === "undefined") {
    loggedHomePhone = null
  } else {
    loggedHomePhone = storage.rawGet("HomePhone")
  }
  if (storage.rawGet("CellPhone") === undefined || storage.rawGet("CellPhone") === "undefined") {
    loggedCellPhone = null
  } else {
    loggedCellPhone = storage.rawGet("CellPhone")
  }
  if (storage.rawGet("FarmStreetAddress2") === undefined || storage.rawGet("FarmStreetAddress2") === "undefined") {
    _Farm_LLC_Address2 = ""
  } else {
    _Farm_LLC_Address2 = storage.rawGet("FarmStreetAddress2")
  }
  if (storage.rawGet("FarmCity") === undefined || storage.rawGet("FarmCity") === "undefined") {
    _Farm_LLC_City = ""
  } else {
    _Farm_LLC_City = storage.rawGet("FarmCity")
  }
  if (storage.rawGet("Farm_LLC_State") === undefined || storage.rawGet("Farm_LLC_State") === "undefined") {
    _Farm_LLC_State = ""
  } else {
    _Farm_LLC_State = storage.rawGet("Farm_LLC_State")
  }
  if (storage.rawGet("zip_code") === undefined || storage.rawGet("zip_code") === "undefined") {
    _Farm_LLC_Zip = ""
  } else {
    _Farm_LLC_Zip = storage.rawGet("zip_code")
  }
  if (storage.rawGet("FarmEmail") === undefined || storage.rawGet("FarmEmail") === "undefined") {
    _Farm_LLC_Email = ""
  } else {
    _Farm_LLC_Email = storage.rawGet("FarmEmail")
  }
  if (storage.rawGet("FarmID") === undefined || storage.rawGet("FarmID") === "undefined") {
    _Farm_LLC_Id = ""
  } else {
    _Farm_LLC_Id = storage.rawGet("FarmID")
  }
  if (storage.rawGet("FarmDisplayName") === undefined || storage.rawGet("FarmDisplayName") === "undefined") {
    _Farm_Display_Name = ""
  } else {
    _Farm_Display_Name = storage.rawGet("FarmDisplayName")
  }

  var _subscriptionSignedName = storage.rawGet("LoggedName")
  var today = new Date()

  var day = String(today.getDate()).padStart(2, "0")
  var month = String(today.getMonth() + 1).padStart(2, "0") // January is 0!
  var year = today.getFullYear()
  var _userTitle = ""
  var _utilityDisplayName = JSON.parse(storage.rawGet("UtilitySessionDetails"))["5"]

  var monthName = new Intl.DateTimeFormat("en-US", { month: "long" }).format(today)

  var _formattedDate3 = `${monthName} ${day} ${year}`

  var _formattedDate = `${day} ${month} ${year}`
  var formattedDate2 = `${month}/${day}/${year}`

  ///values for co disclosure
  var _retailCustomerNumber = storage.rawGet("UanNumber") ?? "UAN"
  var _subOrgName = "Company name"

  var utilityDetails = storage.rawGet("UtilitySessionDetails")
  var _showSubscription = false
  var _showDisclosure = false
  var _showPayment = false
  var _stageName
  var _standardDiscount = storage.rawGet("FarmOpenDiscount") ?? ""
  var _lmiDiscount = storage.rawGet("FarmLMIDiscount") ?? ""
  if (utilityDetails) {
    utilityDetails = JSON.parse(utilityDetails)
    _stageName = utilityDetails["13"].name
  }

  async function sendSubAgreementBase64Toserverless() {
__ea_trace("modules/consent/consent-il-pay.ts","sendSubAgreementBase64Toserverless",[],[]);
    return new Promise(async (resolve, reject) => {
__ea_trace("modules/consent/consent-il-pay.ts","(anon)",[resolve,reject],["resolve","reject"]);
      try {
        if (!(await ensureTemplatesReady())) return resolve(false)

        // Create a container for the HTML template
        const container = document.createElement("div")
        container.innerHTML = finalSubTemp

        document.body.appendChild(container)

        // Apply fixed styles for exact rendering
        const style = document.createElement("style")
        style.innerHTML = `
                                  * {
                                      font-family: 'Times New Roman', serif !important; /* Consistent font */
                                      font-size: 12pt !important; /* Uniform text size */
                                      line-height: 1.5 !important; /* Uniform line height */
                                      margin: 0;
                                      padding: 0;
                                      box-sizing: border-box;
                                  }
                                  body {
                                      width: 660px; /* A4 fixed width */
                                      max-width: 660px;
                                      min-height: 297mm; /* A4 fixed height */
                                      margin: 0 auto;
                                      padding: 100px 90px; /* Uniform padding */
                                      background: white; /* Force white background */
                                  }
                                  .pdf-page-break {
                                      page-break-before: always;
                                  }
                                  .pdf-content {
                                      padding-bottom: 20mm; /* Avoid cutoff at the bottom */
                                  }
                              `
        document.head.appendChild(style)

        // Wait for fonts to load
        await document.fonts.ready

        // Add delay for rendering consistency
        await new Promise((resolve) => setTimeout(resolve, 500))

        // Generate the PDF Blob with fixed dimensions
        try {
          var pdfBlob = await html2pdf()
            .from(container)
            .set({
              margin: 10, // No margins (content fits within A4 size)
              filename: "Subscription_Agreement.pdf",
              image: { type: "jpeg", quality: 0.98 }, // High-quality images
              html2canvas: {
                scale: 1.5, // Use fixed scaling for all devices
                useCORS: true,
                dpi: 96, // Force 96 DPI for consistency
                scrollX: 0,
                scrollY: 0,
                windowWidth: 210 * 4, // Set exact rendering width (A4 size in px @ 96 DPI)
                windowHeight: 297 * 4, // Set exact rendering height (A4 size in px @ 96 DPI)
              },
              jsPDF: {
                unit: "mm",
                format: "a4",
                orientation: "portrait",
              },
            })
            .toPdf()
            .output("blob")
        } catch {
          console.error("pdfBlob")
        }

        // Cleanup temporary elements
        document.body.removeChild(container)
        document.head.removeChild(style)

        // Convert Blob to Base64
        try {
          var base64File = await blobToBase64(pdfBlob)
        } catch {
          console.error("base64File")
        }

        // Send Base64 to server
        const projectName = `Sub ${storage.rawGet("LoggedName")} ${storage.rawGet("dealId")}`
        const userEmail = storage.rawGet("userEmail")
        if (isAndroidDevice) {
          var _data = {
            base64File: base64File,
            pdfName: projectName,
            email: userEmail,
            templateId: "CBJCHBCAABAAMdDixNIZW33GqHIAadyI39yIRkqatNN1",
          }
        } else {
          var data = {
            base64File: base64File,
            pdfName: projectName,
            email: userEmail,
            templateId: "CBJCHBCAABAAFyfa6VPceAv3Ts5foJhM-XahKm07TFVv",
          }
        }

        const response = await fetch("https://portal.nidish.com/stripeint/webhook/get-signature-url", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        })

        if (!response.ok) {
          console.error(`Server error: ${response.status}`)
          reject(new Error(`Error uploading agreement. Status: ${response.status}`))
        }

        const result = await response.json()
        const SubesignUrl = result.data.signingUrlSetInfos[0].signingUrls[0].esignUrl
        const SubagreementId = result.agreementId

        // Store agreement ID and update UI
        storage.rawSet("SubagreementId", SubagreementId)
        updateAgreementId(SubagreementId, "subscription_adobe_agreement_id")

        document.querySelector("#subsignPdf").src = SubesignUrl
        document.querySelector("#subbeforesignPdf").style.display = "none"
        document.querySelector("#subsignPdfTitle").style.display = "block"
        document.querySelector("#subsignPdf").style.display = "block"
        document.querySelector("#page_3_payment_required_consent_widget #thirdStepButton").style.display = "none"
        document.querySelector("#page_3_payment_required_consent_widget #firstStepButton").style.display = "none"
        document.querySelector("#page_3_payment_required_consent_widget #secondStepButton").style.display = "block"
        setTimeout(() => {
__ea_trace("modules/consent/consent-il-pay.ts","(anon)",[],[]);
          closeProgressBar()
        }, 10000)

        resolve()
      } catch (error) {
        console.error("Error:", error)
        reject(error)
      }
    })
  }
  // Convert Blob to Base64
  function blobToBase64(blob) {
__ea_trace("modules/consent/consent-il-pay.ts","blobToBase64",[blob],["blob"]);
    return new Promise((resolve, reject) => {
__ea_trace("modules/consent/consent-il-pay.ts","(anon)",[resolve,reject],["resolve","reject"]);
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result.split(",")[1]) // Remove Base64 prefix
      reader.onerror = reject
      reader.readAsDataURL(blob)
    })
  }

  document
    .querySelector("#page_3_payment_required_consent_widget #secondStepButton")
    .addEventListener("click", async () => {
__ea_trace("modules/consent/consent-il-pay.ts","(anon)",[],[]);
      openProgressBar("We are saving your signed document to your account")
      await sendSubAgreementIdToGetStatus()
    })
  document
    .querySelector("#page_3_payment_required_consent_widget #subproccedToSign")
    .addEventListener("click", async () => {
__ea_trace("modules/consent/consent-il-pay.ts","(anon)",[],[]);})

  // currently working functions below
  var finalSubTemp
  //     var finalDisclosureTemp;

  // Every Illinois enrollment uses the same subscription agreement, so
  // there is no state switch here — only the deal-record values and the
  // Android page-break variant differ.
  async function setTemplates() {
__ea_trace("modules/consent/consent-il-pay.ts","setTemplates",[],[]);
    finalSubTemp = await loadAgreement(
      root,
      isAndroidDevice ? "data-illinois-subscription-android-template-url" : "data-illinois-subscription-template-url",
      await agreementValuesReady,
    )
  }

  var templateGate = createTemplateGate(setTemplates)
  var ensureTemplatesReady = templateGate.ensureReady

  var is_enrolled_for_bayou = storage.rawGet("is_enrolled_for_bayou")

  // ─── Wire formerly-inline handlers ────────────────────────────────────────────

  // Payment type radio buttons
  bind("#ACH", "click", () => showContent("bank"))
  bind("#CreditCard", "click", () => showContent("credit"))
}
